[
  {
    "id": "mission.7000-aar-gamle-muslinger",
    "title": "7.000 år gamle muslinger",
    "description": "Find sporene efter stenalderens måltider i skrænten ved Fiskerhuset uden at røre eller samle noget op.",
    "place": "Køkkenmøddingen ved Fiskerhuset",
    "address": "Fiskerhuset, Tirsbæk Strandvej, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.706917557,
    "longitude": 9.585135878
  },
  {
    "id": "mission.arbejdernes-bygning.demo-49",
    "title": "Arbejdernes årstal",
    "description": "Huset blev bygget til fællesskab. Find det historiske årstal på facaden eller den faste plade.",
    "place": "Bygningen – Arbejdernes Forsamlingsbygning",
    "address": "Ved Anlæget 14, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7067,
    "longitude": 9.5357
  },
  {
    "id": "mission.bredballe-idraetsforening-navnet-paa-stedet-4e488e43",
    "title": "Bredballe Idrætsforening",
    "description": "En historie om Bredballe Idrætsforening",
    "place": "Bredballe Idrætscenter",
    "address": "Nørremarksvej 159, Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.719442,
    "longitude": 9.591104
  },
  {
    "id": "mission.bredballe-kirkebakken.bredballe",
    "title": "Bredballe Kirke",
    "description": "På Kirkebakken lå kirke, skole, mølle og mødehus tæt på hinanden.",
    "place": "Kirkebakken i Bredballe",
    "address": "Kirkebakken, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.714495,
    "longitude": 9.607526
  },
  {
    "id": "mission.ravningbroen.broen-der-krydsede-engen",
    "title": "Broen, der krydsede engen",
    "description": "En vikingebro ligger stadig gemt under engen. Find de steder, hvor museet har løftet dens ender frem igen.",
    "place": "Ravningbroen",
    "address": "Ravningvej 25, 7182 Bredsten",
    "postalCode": "7182",
    "status": "draft",
    "latitude": 55.674428,
    "longitude": 9.346803
  },
  {
    "id": "mission.mamrelund.demo-48",
    "title": "Buen i missionshuset",
    "description": "Et gammelt samlingshus er blevet bolig, men en kirkelig inspireret form sidder stadig i facaden.",
    "place": "Mamrelund",
    "address": "Jacob Gades Stræde 2, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7088,
    "longitude": 9.5348
  },
  {
    "id": "mission.baekken-der-drev-to-moeller",
    "title": "Bækken, der drev to møller",
    "description": "Følg vandets fald og opdag, hvordan den samme bæk kunne levere kraft to gange.",
    "place": "Tirsbæk Overmølle",
    "address": "Tirsbækvej 125, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.7174,
    "longitude": 9.63409
  },
  {
    "id": "mission.boelgen.den-femte-besked",
    "title": "Bølgen: Den skjulte besked",
    "description": "En glemt besked ved fjorden kunne først åbnes, når alle bølger stod færdige.",
    "place": "Bølgen",
    "address": "Havneøen, 7100 Vejle",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.710503,
    "longitude": 9.557547
  },
  {
    "id": "mission.baaden-til-kongehuset",
    "title": "Båden til kongehuset",
    "description": "Find bådtypen fra Bredballe, som også blev sejlet af medlemmer af kongehuset.",
    "place": "Det tidligere Børresen Bådebyggeri",
    "address": "Brønsodde, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70545,
    "longitude": 9.60275
  },
  {
    "id": "mission.dampskibene-fra-bredballe",
    "title": "Dampskibene fra Bredballe",
    "description": "Find vejnavnet, der husker tiden, hvor en udflugt begyndte med billet og damp på fjorden.",
    "place": "Dampskibsvejen ved fjorden",
    "address": "Dampskibsvejen, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70606,
    "longitude": 9.60196
  },
  {
    "id": "mission.skihopbakken-i-skoven",
    "title": "Danmarks første skihopbakke",
    "description": "Find den menneskeskabte profil efter en skihopbakke fra krigsårene.",
    "place": "Skihopbakken ved Gyllinghøj",
    "address": "Nørreskoven ved Gyllinghøj, 7100 Vejle",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.7126,
    "longitude": 9.5816
  },
  {
    "id": "mission.midgaardsbroenden.tre-l-venger",
    "title": "Danmarks tre løveunger",
    "description": "Tre små løver er flyttet fra våbenskjoldets alvor til byens leg.",
    "place": "Midgårdsbrønden",
    "address": "Torvegade ved Orla Lehmannsgade, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7081,
    "longitude": 9.5365
  },
  {
    "id": "mission.danmarks-aeldste-vinbjerg",
    "title": "Danmarks ældste vinbjerg",
    "description": "Find den overraskende del af en gammel renæssancehave, hvor terrasserne blev brugt til vin.",
    "place": "Vinbjerget i Tirsbæk Slotspark",
    "address": "Tirsbækvej 135, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.71353,
    "longitude": 9.6392
  },
  {
    "id": "mission.de-to-naesten-usynlige-hoeje",
    "title": "De to næsten usynlige høje",
    "description": "Find to diskrete spor efter mennesker, der brugte skoven flere tusinde år før os.",
    "place": "Bronzealderhøjene ved Bybækvej",
    "address": "Bybækvej i Nørreskoven, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.71395,
    "longitude": 9.5832
  },
  {
    "id": "mission.broen.den-forsvundne-landevej",
    "title": "Den forsvundne landevej",
    "description": "Den forsvundne landevej gemmer på en hemmelighed.",
    "place": "Den gamle bro i Tirsbæk Bakker",
    "address": "Tirsbæk Bakker, 7120 Vejle",
    "postalCode": "7120",
    "status": "published",
    "latitude": 55.72848601856638,
    "longitude": 9.626961636650389
  },
  {
    "id": "mission.st-peders-kilde.irkantet-ramme",
    "title": "Den runde kilde i en firkant",
    "description": "Kilden gemmer én form inden i en anden. Se på den yderste træramme – ikke selve vandhullet.",
    "place": "St. Peders Kilde",
    "address": "Ved Øster Nykirke, Hærvejen 309, 7323 Give",
    "postalCode": "7323",
    "status": "draft",
    "latitude": 55.8404,
    "longitude": 9.3845
  },
  {
    "id": "mission.ny-opgave-2",
    "title": "Den verdensberømte komponist",
    "description": "Stedet hvor en verdensberømt komponist blev født.",
    "place": "Nyt sted",
    "address": "Give",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.7077995,
    "longitude": 9.538869
  },
  {
    "id": "mission.dronning-thyra-paa-stejlbjerg",
    "title": "Dronning Thyra på Stejlbjerg",
    "description": "Stå på højdedraget og genfortæl sagnet om dronningen, der så ud over fjorden.",
    "place": "Stejlbjergparken",
    "address": "Stejlbjergparken, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70939,
    "longitude": 9.60537
  },
  {
    "id": "mission.egtvedpigens-verden.em-ort-llezoner",
    "title": "Fem verdener uden vægge",
    "description": "Gå gennem et museum uden vægge og hold øje med overgangen mellem historierne.",
    "place": "Egtvedpigens Verden",
    "address": "Egtved Holt 12, 6040 Egtved",
    "postalCode": "6040",
    "status": "draft",
    "latitude": 55.6208,
    "longitude": 9.2998
  },
  {
    "id": "mission.raadhustorvet.fire-erhverv",
    "title": "Fire erhverv foran rådhuset",
    "description": "To stenfamilier på torvet gemmer på spor efter det Vejle, der arbejdede.",
    "place": "Erhvervsskulpturerne på Rådhustorvet",
    "address": "Rådhustorvet 1, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.707971,
    "longitude": 9.532491
  },
  {
    "id": "mission.villa-flegborg.demo-50",
    "title": "Fire etager til støberiejeren",
    "description": "En industrimands bolig skulle kunne ses. Se på hovedfacaden fra fortovet.",
    "place": "Villa Flegborg",
    "address": "Flegborg 6, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7083,
    "longitude": 9.5369
  },
  {
    "id": "mission.engelsholm-slot.fire-taarne-ved-soeen",
    "title": "Fire tårne ved søen",
    "description": "Se slottet på afstand som en geometrisk figur. Tæl tårnene i hjørnerne.",
    "place": "Engelsholm Slot",
    "address": "Engelsholmvej 6, 7182 Bredsten",
    "postalCode": "7182",
    "status": "draft",
    "latitude": 55.715222,
    "longitude": 9.319221
  },
  {
    "id": "mission.fiskerhuset-ved-tirsbaek-strand",
    "title": "Fiskerhuset ved Tirsbæk Strand",
    "description": "Sammenlign fortid og nutid ved huset, hvor fiskerfamilier levede tæt på fjorden.",
    "place": "Fiskerhuset",
    "address": "Fiskerhuset, Tirsbæk Strandvej, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.70692,
    "longitude": 9.58514
  },
  {
    "id": "mission.fiskernes-stejleplads",
    "title": "Fiskernes stejleplads",
    "description": "Genfind den åbne arbejdsplads, hvor fiskernes garn blev tjæret, repareret og tørret.",
    "place": "Stejlepladsen ved Dampskibsvejen",
    "address": "Dampskibsvejen ved Strandvejen, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70615,
    "longitude": 9.60245
  },
  {
    "id": "mission.fjordenhus-arkitektens-sten",
    "title": "Fjordenhus: Arkitektens sten",
    "description": "Kan du finde arkitektens sten?",
    "place": "Fjordenhus: Arkitektens sten",
    "address": "Vejle Øst",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.705946,
    "longitude": 9.55505
  },
  {
    "id": "mission.fjordenhus.vandets-tromler",
    "title": "Fjordenhus: Mursten",
    "description": "En murers drøm eller mareridt?",
    "place": "Fjordenhus",
    "address": "Havneøen 1, 7100 Vejle",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.706393,
    "longitude": 9.55436
  },
  {
    "id": "mission.fra-konditori-til-udstoppede-dyr",
    "title": "Fra konditori til udstoppede dyr",
    "description": "Opklar rækkefølgen i et hus, der skiftede fra kager og kaffe til et helt andet håndværk.",
    "place": "Det tidligere konditori",
    "address": "Strandvejen 50–52, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "draft",
    "latitude": 55.70934,
    "longitude": 9.61733
  },
  {
    "id": "mission.margrethediget.demo-39",
    "title": "Grøft før vold",
    "description": "Et gammelt forsvarsværk består af to jordformer. Kom kun fra den anviste sydlige sti.",
    "place": "Margrethediget",
    "address": "Ved Hærvejen nær Hærvejen 317, 7173 Vonge",
    "postalCode": "7173",
    "status": "draft",
    "latitude": 55.8936,
    "longitude": 9.197
  },
  {
    "id": "mission.jelling.den-store-jellingsten",
    "title": "Haralds budskab i sten",
    "description": "Harald Blåtand lod både ord og billeder hugge i stenen.",
    "place": "Den store Jellingsten",
    "address": "Monumentområdet ved Thyrasvej 1, 7300 Jelling",
    "postalCode": "7300",
    "status": "draft",
    "latitude": 55.756581,
    "longitude": 9.419546
  },
  {
    "id": "mission.havnen-bygget-af-gamle-pramme",
    "title": "Havnen bygget af gamle pramme",
    "description": "Se efter sporene af den enkle genbrugsløsning, der blev begyndelsen på bådehavnen ved Brønsodde.",
    "place": "Brønsodde Bådehavn",
    "address": "Brønsodde, Strandvejen, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "draft",
    "latitude": 55.70495,
    "longitude": 9.60316
  },
  {
    "id": "mission.noerreskov-spor.bredballe",
    "title": "Helligkilden i Nørreskoven",
    "description": "Helligkilden i Nørreskoven, Vejle, 1920'erne",
    "place": "Nørreskovens krigsspor og sagnspor",
    "address": "Nørreskoven ved Bybæk, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.7354,
    "longitude": 9.5865
  },
  {
    "id": "mission.hjemmet-ved-vejle-fjord",
    "title": "Hjemmet ved Vejle Fjord",
    "description": "Find navnene på de to historiske hovedbygninger i det tidligere børne- og skolehjem.",
    "place": "Det tidligere Skolehjem ved Vejle Fjord",
    "address": "Solvej 62, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.71331,
    "longitude": 9.59718
  },
  {
    "id": "mission.solhjul.ind-mod-midten",
    "title": "Hjulet der læner sig ind",
    "description": "Det enorme hjul står ikke helt lodret. Afgør hældningen fra et sikkert fortov.",
    "place": "Solhjul",
    "address": "Rundkørslen ved Vejlevej og Herningvej, 7323 Give",
    "postalCode": "7323",
    "status": "draft",
    "latitude": 55.8462,
    "longitude": 9.0228
  },
  {
    "id": "mission.hulvejen-foer-bilerne",
    "title": "Hulvejen før bilerne",
    "description": "Læs en gammel vej i terrænet, selv om hjulspor og fødder for længst er væk.",
    "place": "Hulvejen i Tirsbækskovene",
    "address": "Skovene vest for Tirsbæk Gods, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "draft",
    "latitude": 55.71475,
    "longitude": 9.6272
  },
  {
    "id": "mission.hundrede-ton-sten-under-vandet",
    "title": "Hundrede ton sten under vandet",
    "description": "Find stedet, hvor en stor bunke sten blev til nye hjem for livet i Vejle Fjord.",
    "place": "Tirsbæk Strand",
    "address": "Tirsbæk Strand, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70875,
    "longitude": 9.63246
  },
  {
    "id": "mission.himmelstigen.demo-36",
    "title": "Hvem gjorde stenen?",
    "description": "En nutidig kunstner har signeret som en runemester. Find sætningen, og aflæs fornavnet efter ‘Jeg’.",
    "place": "Himmelstigen",
    "address": "Banegårdspladsen 8, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7098,
    "longitude": 9.5351
  },
  {
    "id": "mission.firehoeje.demo-37",
    "title": "Højene der tæller sig selv",
    "description": "Et stednavn kan være en ledetråd, men I skal bevise det med landskabet.",
    "place": "Firehøje",
    "address": "Firehøje nord for Randbøl Kirke, nær Randbølvej 69, 7183 Randbøl",
    "postalCode": "7183",
    "status": "draft",
    "latitude": 55.6958,
    "longitude": 9.259
  },
  {
    "id": "mission.broensodde-vaerft.bredballe",
    "title": "Håndværket ved Brønsodde",
    "description": "Ved Brønsodde mødes fjord, fiskerhuse og værftshistorie. Kig efter stedets maritime spor fra sikre, offentlige arealer.",
    "place": "Brønsodde og A. Ustrups bådeværft",
    "address": "Brønsodde, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "draft",
    "latitude": 55.7158,
    "longitude": 9.6102
  },
  {
    "id": "mission.jeppes-kilde-gav-vejen-navn",
    "title": "Jeppes kilde gav vejen navn",
    "description": "Find kilden og personen, hvis fornavn stadig lever videre i Bredballes vejnavn.",
    "place": "Jeppes Kilde",
    "address": "Jeppes Kilde, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "draft",
    "latitude": 55.708586,
    "longitude": 9.612688
  },
  {
    "id": "mission.kaptajnen-der-gik-fra-borde-i-tide",
    "title": "Kaptajnen, der gik fra borde i tide",
    "description": "Find skibsnavnet i historien om kaptajnen, der forlod kommandoen før en berømt katastrofe.",
    "place": "Kaptajn Bertelsens Vej",
    "address": "Kaptajn Bertelsens Vej, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.7077,
    "longitude": 9.608626
  },
  {
    "id": "mission.grejsdal-kirke.em-sider",
    "title": "Kirken med fem sider",
    "description": "Kirken ser enkel ud, men følger ikke en almindelig rektangel. Følg hovedbygningens yderlinje.",
    "place": "Grejsdal Kirke",
    "address": "Grejsdalsvej, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7356,
    "longitude": 9.5565
  },
  {
    "id": "mission.jellingpalisaden.kongens-kaempe-firkant",
    "title": "Kongens kæmpe firkant",
    "description": "Et hegn på størrelse med et helt kvarter tegnede kongens rum omkring monumenterne.",
    "place": "Jellingpalisaden",
    "address": "Monumentområdet ved Thyrasvej 1, 7300 Jelling",
    "postalCode": "7300",
    "status": "draft",
    "latitude": 55.7563,
    "longitude": 9.42085
  },
  {
    "id": "mission.soenderbro.kronen-paa-broen",
    "title": "Kronen på broens fødselsattest",
    "description": "Broen bærer stadig et kongeligt mærke fra den gamle byport mod syd.",
    "place": "Sønderbro",
    "address": "Søndergade over Vejle Å, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.705817,
    "longitude": 9.532433
  },
  {
    "id": "mission.toldkammeret.demo-47",
    "title": "Kronen ved tolden",
    "description": "Staten satte sit mærke på varer ved havnen. Find symbolet på den gamle toldbygning.",
    "place": "Det Kongelige Toldkammer",
    "address": "Havnepladsen 2, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7103,
    "longitude": 9.542
  },
  {
    "id": "mission.pressede-hjerte.demo-35",
    "title": "Kroppen i stenen",
    "description": "Stenen ser ud, som om noget levende er blevet klemt ind i den. Se på hovedformen.",
    "place": "Det Pressede Hjerte",
    "address": "Flegborg 16–18, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.708,
    "longitude": 9.5364
  },
  {
    "id": "mission.kanonkuglehuset.kuglen-fra-1864",
    "title": "Kuglen fra 1864",
    "description": "En lille mørk kugle i muren er et fysisk ekko af 1864. Find den fra fortovet.",
    "place": "Kanonkuglehuset",
    "address": "Nørrebrogade 45, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.712673,
    "longitude": 9.540823
  },
  {
    "id": "mission.broensodde-finhval.bredballe",
    "title": "Kæmpen ved Brønsodde",
    "description": "I 1923 strandede en finhval ved Brønsodde. Historien blev så stor, at den trak folk til fra hele området.",
    "place": "Finhvalen ved Brønsodde",
    "address": "Brønsodde, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.705008,
    "longitude": 9.602965
  },
  {
    "id": "mission.noerup-kirke.demo-41",
    "title": "Løgkuplen på kirketårnet",
    "description": "Tårnet har fået en top, der buer som en køkkenurt. Se på silhuetten fra kirkepladsen.",
    "place": "Nørup Kirke",
    "address": "De Lichtenbergs Vej 32, 7182 Bredsten",
    "postalCode": "7182",
    "status": "draft",
    "latitude": 55.7207,
    "longitude": 9.3679
  },
  {
    "id": "mission.toerskind-mand.manden-med-tre-ben",
    "title": "Manden med tre ben",
    "description": "I grusgraven står en mand, der ikke følger menneskets anatomi. Tæl kun det, der bærer kroppen.",
    "place": "Tørskind-mand",
    "address": "Tørskindvej 98A, 6040 Egtved",
    "postalCode": "6040",
    "status": "draft",
    "latitude": 55.648848,
    "longitude": 9.310882
  },
  {
    "id": "mission.noerretorv-lysmast.demo-45",
    "title": "Masten der ikke står lige",
    "description": "Noget på torvet ser forkert ud med vilje. Brug en huskant som lodlinje.",
    "place": "Den skæve lysmast på Nørretorv",
    "address": "Nørretorv, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7105,
    "longitude": 9.5356
  },
  {
    "id": "mission.mestrenes-hjemmebane-d7dba3de",
    "title": "Mestrenes hjemmebane",
    "description": "Fra et træhus ved Horsensvej til fem danske mesterskaber og en spiller i Europas top. Oplev historien om Vejle Boldklubs hjemmebaner, og find den fysiske kode ved det nye stadion.",
    "place": "Det nye Vejle Stadion",
    "address": "Roms Hule 6, 7100 Vejle",
    "postalCode": "7100",
    "status": "fieldTestReady",
    "latitude": 55.714406,
    "longitude": 9.556238
  },
  {
    "id": "mission.munkebjerg-udsigt-paa-menuen-23fed41d",
    "title": "Munkebjerg – udsigt på menuen",
    "description": "Et måltid, en overnatning og udsigt over Vejle Fjord. Munkebjerg lokkede gæster op i skoven – og i en periode kunne de lade en rullende trappe klare opstigningen. Find sporet efter den usædvanlige udflugt.",
    "place": "Munkebjergtrappen – øverste adgang",
    "address": "Munkebjergvej 125, 7100 Vejle",
    "postalCode": "7100",
    "status": "fieldTestReady",
    "latitude": 55.6875382,
    "longitude": 9.6160944
  },
  {
    "id": "mission.spinderihallerne.spinderihallerne",
    "title": "Navnet på tekstilbyen",
    "description": "En hel industribygning har fået sit gamle arbejde med ind i det nye navn. Find hovedindgangen.",
    "place": "Spinderihallerne",
    "address": "Spinderigade 11E, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7133,
    "longitude": 9.5274
  },
  {
    "id": "mission.oldtidsdyssen-der-er-falsk",
    "title": "Oldtidsdyssen, der er falsk",
    "description": "Afslør hvorfor den dysseagtige portal i Nørreskoven ikke er et oldtidsminde.",
    "place": "Frederik VII’s Høj",
    "address": "Helligkildevej ved indgangen til Dyrehaven, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7092,
    "longitude": 9.5683
  },
  {
    "id": "mission.kunstbroerne.demo-43",
    "title": "Otte broer, otte rækværker",
    "description": "Hver overgang over åen har fået sit eget kunstneriske håndtryk. Tæl broer på én fast rute.",
    "place": "Kunstbroerne over Mølleåen",
    "address": "Mølleå-forløbet mellem Dæmningen og Vissingsgade, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7084,
    "longitude": 9.5325
  },
  {
    "id": "mission.pansergravene-gennem-bredballe",
    "title": "Pansergravene i Bredballe",
    "description": "Følg et næsten slettet forsvarsspor fra besættelsestiden gennem det moderne Bredballe.",
    "place": "Pansergravenes omtrentlige linje",
    "address": "Kirkebakken ved Forårsvej, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.71055,
    "longitude": 9.61395
  },
  {
    "id": "mission.skyttehushaven.otte-sider",
    "title": "Pavillonen med otte sider",
    "description": "Her dansede vejlenserne med fjorden som nabo. Gå rundt om den gamle pavillons hovedkrop.",
    "place": "Den gamle ottekant i Skyttehushaven",
    "address": "Skyttehushaven ved Tirsbæk Strandvej, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.6976,
    "longitude": 9.562
  },
  {
    "id": "mission.lille-jellingsten.runer-der-staar-op",
    "title": "Runer der står op",
    "description": "På den mindre kongesten går runerne anderledes end moderne tekst. Se på retningen – uden at kunne læse dem.",
    "place": "Den lille Jellingsten",
    "address": "Thyrasvej 1, 7300 Jelling",
    "postalCode": "7300",
    "status": "draft",
    "latitude": 55.756714,
    "longitude": 9.419718
  },
  {
    "id": "mission.brandbomberne-der-naesten-ikke-virkede",
    "title": "Sabotagen på værftet",
    "description": "Afslør målet for en af Vejles tidlige sabotageaktioner under besættelsen.",
    "place": "A. Ustrups Skibsværft",
    "address": "Brønsodde ved Dampskibsvejen, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.706891,
    "longitude": 9.600177
  },
  {
    "id": "mission.troendur-p-hus.demo-44",
    "title": "Seks lag af glas",
    "description": "Farverne skjuler et praktisk hus. Følg de vandrette lag bag glasset og tæl niveauerne.",
    "place": "Tróndur – Vejles P-hus",
    "address": "Volmers Plads, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.708,
    "longitude": 9.5341
  },
  {
    "id": "mission.skolestenen.hjem",
    "title": "Skole og hvad?",
    "description": "En gammel pædagogisk sætning er bevaret ved museet. Find stenen og udfyld ordet.",
    "place": "Skolestenen ved Kellers Minde",
    "address": "H.O. Wildenskovsvej 10, 7080 Børkop",
    "postalCode": "7080",
    "status": "draft",
    "latitude": 55.6711,
    "longitude": 9.6703
  },
  {
    "id": "mission.skolen-ved-stranden",
    "title": "Skolen ved stranden",
    "description": "Brug et gammelt klassefoto til at finde året, hvor Bredballes skole ved stranden blev bygget.",
    "place": "Den tidligere Bredballe Strandskole",
    "address": "Tagesvej 1, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70908,
    "longitude": 9.60693
  },
  {
    "id": "mission.skoven-efter-lejesoldaterne",
    "title": "Skoven efter lejesoldaterne",
    "description": "Afkod et skovnavn, der fører tilbage til svenskekrigen og et mørkt lokalt sagn.",
    "place": "Polakkerskoven",
    "address": "Polakkerskov, Nørreskoven, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.71977,
    "longitude": 9.58167
  },
  {
    "id": "mission.skovens-aeldste-kaempe",
    "title": "Skovens ældste kæmpe",
    "description": "Find navnepladen på Nørreskovens ældste træ og afslør det kongelige navn.",
    "place": "Kong Hans’ Eg",
    "address": "Nørreskoven nord for Vejle Stadion, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.714588367,
    "longitude": 9.557552366
  },
  {
    "id": "mission.bybaek-kurhotel.bredballe",
    "title": "Skovkroen i Bybæk",
    "description": "Skovkroen i Bybæk har skiftet navn og funktion flere gange. Følg strandstien og find stedet, hvor gæster kom for frisk luft og ophold.",
    "place": "Bybæk Kurhotel og Skovkroen",
    "address": "Bybæk Strand, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "fieldTestReady",
    "latitude": 55.70732,
    "longitude": 9.587189
  },
  {
    "id": "mission.soldaten-i-boegen",
    "title": "Soldaterbøgen",
    "description": "Find den indridsede soldat i en gammel bøg og aflæs den historiske kode uden at røre træet.",
    "place": "Soldaterbøgen",
    "address": "Nord for Store Pytsø, Nørreskoven, 7100 Vejle",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.711645,
    "longitude": 9.570015
  },
  {
    "id": "mission.restaurant-tirsbaek.bredballe",
    "title": "Sommerlivet ved fjorden",
    "description": "Ved Tirsbæk kom gæster for at spise, bade og opleve fjorden. Find stedet og tænk som en udflugtsgæst fra dengang.",
    "place": "Restaurant Tirsbæk",
    "address": "Tirsbæk Strand, 7120 Vejle Øst",
    "postalCode": "7120",
    "status": "draft",
    "latitude": 55.6957,
    "longitude": 9.6168
  },
  {
    "id": "mission.bomuldsspinderiet.demo-46",
    "title": "Spinderiets taktfaste vinduer",
    "description": "En fabrik gentager den samme rytme. Find facaden og vælg det tydeligste gentagne element.",
    "place": "Det gamle Vejle Bomuldsspinderi",
    "address": "Industribygninger øst for Vejle Station mellem banen og Havnegade, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7078,
    "longitude": 9.542
  },
  {
    "id": "mission.vejle-gaagade.runefliserne",
    "title": "Spor i gågaden",
    "description": "Mellem helt almindelige fliser i Vejles gågade gemmer moderne spor af runer sig. Find dem på den feltmarkerede strækning.",
    "place": "Runefliserne i Vejles gågade",
    "address": "Gågadeforløbet Søndergade–Torvegade–Nørregade, 7100 Vejle; fuld strækning skal feltfastlægges",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.70647,
    "longitude": 9.53262
  },
  {
    "id": "mission.sct-nicolai.de-23-hoveder",
    "title": "Spor i kirkemuren",
    "description": "I kirkemuren gemmer et gådefuldt spor efter tidligere vejlenseres begravelser sig.",
    "place": "Sct. Nicolai Kirkes hovedskalfrise",
    "address": "Kirketorvet 1, 7100 Vejle",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.707495,
    "longitude": 9.534898
  },
  {
    "id": "mission.randboelstenen.stenen-der-blev-samlet-igen",
    "title": "Stenen der blev samlet igen",
    "description": "En vikingesten på heden blev sprængt og siden samlet igen. Kan I se sporene efter redningen?",
    "place": "Randbølstenen",
    "address": "Randbøl Hede ved den gamle Hærvej, 7183 Randbøl",
    "postalCode": "7183",
    "status": "draft",
    "latitude": 55.656,
    "longitude": 9.21431
  },
  {
    "id": "mission.jelling-skibssaetningen.stenskibet-under-hoejene",
    "title": "Stenskibet under højene",
    "description": "Før højene kom til, tegnede sten et enormt fartøj i landskabet.",
    "place": "Jelling-skibssætningen",
    "address": "Monumentområdet ved Thyrasvej 1, 7300 Jelling",
    "postalCode": "7300",
    "status": "draft",
    "latitude": 55.75645,
    "longitude": 9.41995
  },
  {
    "id": "mission.tinnet-badeland.demo-38",
    "title": "Svømmebassinet i skoven",
    "description": "Skoven skjuler rester af et sted, hvor man engang svømmede. Find det største bassin.",
    "place": "Det gamle badeland ved Tinnet Krat",
    "address": "Ved Gudenåens udspring, Hærvejen 317, 7173 Vonge",
    "postalCode": "7173",
    "status": "draft",
    "latitude": 55.8958,
    "longitude": 9.1915
  },
  {
    "id": "mission.stokbro.demo-40",
    "title": "Syv gamle rækværksstolper",
    "description": "Broens to sider er ikke ens. Tæl granitstolperne kun fra et sikkert offentligt punkt.",
    "place": "Stokbro over Højen Å",
    "address": "Stokbro over Højen Å ved Højen, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7449,
    "longitude": 9.5101
  },
  {
    "id": "mission.boerkop-vandmoelle.to-hjul-driver-moellen",
    "title": "To hjul driver møllen",
    "description": "Vandet skulle ikke nøjes med ét hjul. Find møllens arbejdsside og tæl de store hjul.",
    "place": "Børkop Vandmølle",
    "address": "Vandmøllevej 4, 7080 Børkop",
    "postalCode": "7080",
    "status": "draft",
    "latitude": 55.638041,
    "longitude": 9.662521
  },
  {
    "id": "mission.jellinghoeje.to-h-je",
    "title": "To kongelige høje",
    "description": "Kirken står mellem monumentale jordformer. Tæl kun de høje, der hører til verdensarvsanlægget.",
    "place": "Jellinghøjene",
    "address": "Monumentområdet ved Thyrasvej 1, 7300 Jelling",
    "postalCode": "7300",
    "status": "draft",
    "latitude": 55.7559,
    "longitude": 9.4189
  },
  {
    "id": "mission.lille-tycho-brahe.to-r-r",
    "title": "To rør mod jord og himmel",
    "description": "En jordkikkert og en himmelkikkert mødes i ét værk. Tæl de store rør uden at klatre.",
    "place": "Lille Tycho Brahe",
    "address": "Tørskindvej 98A, 6040 Egtved",
    "postalCode": "6040",
    "status": "draft",
    "latitude": 55.5792,
    "longitude": 9.2726
  },
  {
    "id": "mission.your-perception.tre-sklptrer",
    "title": "Tre blikke på den samme park",
    "description": "Flyt jer mellem kunstneriske synspunkter og afgør, hvor mange dele der hører til det samme værk.",
    "place": "Your Perception",
    "address": "Parken bag Comwell Kellers Park, H.O. Wildenskovsvej 28, 7080 Børkop",
    "postalCode": "7080",
    "status": "draft",
    "latitude": 55.6695,
    "longitude": 9.6708
  },
  {
    "id": "mission.vildtbanestenene.tre-sten",
    "title": "Tre kongelige grænsesten",
    "description": "Kongens jagtgrænse er flyttet ind til byen. Find gruppen af høje granitsten.",
    "place": "Vildtbanestenene ved den tidligere Amtsgård",
    "address": "Damhaven 12, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7086,
    "longitude": 9.5315
  },
  {
    "id": "mission.middelaldervejen.tre-glaselter",
    "title": "Tre vinduer ned i gaden",
    "description": "Under jeres fødder ligger en ældre gade. Find vinduerne i belægningen, og træd varsomt.",
    "place": "Glasmontrerne over middelaldervejen",
    "address": "Nørregade i gågadeforløbet, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7092,
    "longitude": 9.534
  },
  {
    "id": "mission.bindeballe-station.tre-jernbanevogne",
    "title": "Tre vogne på den nedlagte bane",
    "description": "Togene kører ikke længere, men en lille stamme er blevet stående. Tæl kun de gamle jernbanevogne ved stationen.",
    "place": "Bindeballe Station",
    "address": "Bindeballevej 101, 7183 Randbøl",
    "postalCode": "7183",
    "status": "draft",
    "latitude": 55.6958,
    "longitude": 9.2804
  },
  {
    "id": "mission.ene-ojesten.et-hl",
    "title": "Troldens stenøje",
    "description": "Trolden vogter noget, man både kan se på og se igennem. Undersøg stenen med øjnene.",
    "place": "Ene Øjesten",
    "address": "Skovstien ved Børkop Vandmølle, nær Vandmøllevej 4, 7080 Børkop",
    "postalCode": "7080",
    "status": "draft",
    "latitude": 55.6384,
    "longitude": 9.6618
  },
  {
    "id": "mission.tyskernes-huse-ved-den-hellige-kilde",
    "title": "Tyskernes huse ved den hellige kilde",
    "description": "Find de små skovhuse, der forbinder en gammel helligkilde med besættelsestiden.",
    "place": "Helligkildehusene",
    "address": "Helligkildevej, Nørreskoven, 7100 Vejle",
    "postalCode": "7100",
    "status": "fieldTestReady",
    "latitude": 55.71319,
    "longitude": 9.56688
  },
  {
    "id": "mission.sct-pouls-kirke.demo-34",
    "title": "Tårnet med otte sider",
    "description": "Se op på tårnet uden at træde tilbage i vejen. Tæl de lodrette hovedflader lige under kuplen.",
    "place": "Sct. Pouls Kirke",
    "address": "Vissingsgade 15A, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7095,
    "longitude": 9.5339
  },
  {
    "id": "mission.noerre-kollemorten.colding",
    "title": "Vejen på årstalssiden",
    "description": "Stenen pegede rejsende gennem landet længe før GPS. Brug årstallet som pejlemærke.",
    "place": "Vejviseren ved Nørre Kollemorten",
    "address": "Ved Hærvejen nær Nørre Kollemorten, 7323 Give",
    "postalCode": "7323",
    "status": "draft",
    "latitude": 55.8464,
    "longitude": 9.4094
  },
  {
    "id": "mission.vejle-vindmoelle.korset-paa-moellen",
    "title": "Vejle Vindmølle",
    "description": "På bakken over Vejle står et gammelt maskineri, der engang gjorde vind til arbejde.",
    "place": "Vejle Vindmølle",
    "address": "Søndermarksvej 1, 7100 Vejle",
    "postalCode": "7100",
    "status": "published",
    "latitude": 55.699803,
    "longitude": 9.530297
  },
  {
    "id": "mission.oernebjerget-i-noerreskoven-7e645423",
    "title": "Ørnebjerget i Nørreskoven",
    "description": "Gå på opdagelse ved Ørnebjerget i Nørreskoven i Bredballe. Find stedets spor og undersøg, hvad området fortæller om lokalhistorien.",
    "place": "Ørnebjerget, Nørreskoven",
    "address": "Nørreskoven, Bredballe, Vejle",
    "postalCode": "",
    "status": "draft",
    "latitude": null,
    "longitude": null
  },
  {
    "id": "mission.brandtavlen-1786.",
    "title": "Året da midtbyen brændte",
    "description": "En lille passage fortæller om den dag, hvor byen ændrede sig voldsomt. Find tavlen og aflæs året.",
    "place": "Brandtavlen for katastrofen i 1786",
    "address": "Passagen mellem Vedelsgade og Nørregade, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.7093,
    "longitude": 9.5324
  },
  {
    "id": "mission.smidtske-gaard.aarstallet-over-porten",
    "title": "Årstallet over porten",
    "description": "Købmandsgården har skrevet sin alder lige over indgangen. Find det ældste årstal på portpartiet.",
    "place": "Den Smidtske Gård",
    "address": "Søndergade 14, 7100 Vejle",
    "postalCode": "7100",
    "status": "draft",
    "latitude": 55.707162,
    "longitude": 9.53269
  }
]
